import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Header from "../../components/Layouts/Header";
import Layout from "../../components/Layouts/Layout";
import Footer from "../../components/Layouts/Footer";
import Instance from "../../Utils/Axios";
import { showToast } from "../../Utils";
import useFormValidation from "../../Hooks/useformValidation";
import { signUpSchema } from "../../Utils/validationSchema";
import "../Login/Login.css";
import Select from "react-select";
import { FormGroup } from "react-bootstrap";

export default function SignUp() {
  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [isdCode, setIsdCode] = useState("+91");
  const [otpError, setOtpError] = useState("");
  const [otpAttempts, setOtpAttempts] = useState(0);
  const [resendTimer, setResendTimer] = useState(0);
  const [resendDisabled, setResendDisabled] = useState(false);
  const [isLockedOut, setIsLockedOut] = useState(false);
  const [lockoutTimer, setLockoutTimer] = useState(0);
  const RESEND_COOLDOWN_SECONDS = 30;
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    trigger,
    setError,
  } = useFormValidation(signUpSchema);

  const requestOtp = (isResend = false) => {
    const email = getValues("email");
    if (!email) {
      showToast("Please enter an email address first", "error", "error");
      return;
    }

    if (isResend) {
      if (isLockedOut) return;
      if (otpAttempts >= 5) {
        startLockoutTimer();
        return;
      }
    }

    if (resendDisabled || loading) return;

    setLoading(true);
    Instance.post("/user/emailOTP", { email })
      .then((res) => {
        if (res.data.resCode === "200") {
          showToast(
            isResend ? "OTP resent successfully!" : "OTP sent successfully!",
            "success",
            "success"
          );
          startResendCooldownTimer();
          setIsOtpSent(true);
          if (isResend) setOtpAttempts((prev) => prev + 1);
        } else {
          setError("email", { type: "manual", message: res.data.resMessage });
        }
      })
      .catch((err) => {
        showToast(err?.data?.resMessage, "error", "error");
      })
      .finally(() => setLoading(false));
  };

  const startLockoutTimer = () => {
    setIsLockedOut(true);
    setResendDisabled(true);
    setLockoutTimer(3600);

    setOtpError("Maximum attempts reached. Try again after 1 hour.");

    const lockoutInterval = setInterval(() => {
      setLockoutTimer((prev) => {
        if (prev <= 1) {
          clearInterval(lockoutInterval);
          setOtpAttempts(0);
          setIsLockedOut(false);
          setResendDisabled(false);
          setOtpError("");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const startResendCooldownTimer = () => {
    setResendDisabled(true);
    setResendTimer(RESEND_COOLDOWN_SECONDS);
  };

  useEffect(() => {
    let interval;
    if (resendDisabled && resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            setResendDisabled(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [resendDisabled, resendTimer]);

  const handleVerifyOtpAction = async () => {
    const otp = getValues("otp");
    const email = getValues("email");

    if (!otp) {
      setOtpError("OTP is required.");
      return;
    }

    try {
      const res = await Instance.post("/user/verifyEmailOTP", { email, otp });
      if (res.data.resCode === "200") {
        setIsOtpVerified(true);
        setOtpError("");
        showToast("OTP verified successfully!", "success", "success");
      } else {
        setOtpError(res.data.resMessage || "Incorrect OTP.");
      }
    } catch (err) {
      setOtpError("OTP verification failed.");
    }
  };

  const handleSignUp = (data) => {
    if (!isOtpVerified) {
      showToast("Please verify your OTP first", "error", "error");
      return;
    }

    const payload = {
      title: "mr",
      firstName: data.firstName,
      lastName: data.lastName,
      mobileNumber: data.mobileNumber,
      email: data.email,
      pwd: data.password,
      confirmPwd: data.confirmPwd,
      address: data.address || "",
      country: data.country,
      isdCode: data.isdCode,
    };

    Instance.post("/user/createUser", payload)
      .then((res) => {
        if (res.data.resCode === "200") {
          showToast("Registration successful!", "success", "success");
          setTimeout(() => navigate("/"), 2000);
        } else {
          showToast(res.data.resMessage, "error", "error");
        }
      })
      .catch(() => showToast("Registration failed", "error", "error"));
  };

  useEffect(() => {
    Instance.post("/user/common/countryList", { status: "ACTIVE" }).then((res) => {
      if (res.data.resCode === "200") {
        setCountryList(res.data.message.filter((c) => c.countryName.trim() !== ""));
      }
    });
  }, []);

  useEffect(() => {
    if (countryList.length > 0 && !selectedCountry) {
      const india = countryList.find(c => c.countryName.toLowerCase() === "india");
      if (india) {
        const indiaOpt = { value: india.countryName, label: india.countryName, isdCode: india.isdCode, countryCode: india.countryCode };
        setSelectedCountry(indiaOpt);
        setIsdCode(india.isdCode);
        setValue("country", india.countryName);
        setValue("isdCode", india.isdCode);
      }
    }
  }, [countryList]);

  const customStyles = {
    control: (pd) => ({ ...pd, height: "48px", borderRadius: "6px", border: "1px solid #dee2e6", boxShadow: "none" }),
    singleValue: (pd) => ({ ...pd, fontSize: "14px", display: "flex", alignItems: "center" }),
    indicatorSeparator: () => ({ display: "none" }),
  };

  return (
    <div className="full_screen">
      <Header />
      <div className="content">
        <Layout>
          <div className="col-12 col-lg-6 signup_container">
            <h1 className="mb-4">Create An Account</h1>
            <Form onSubmit={handleSubmit(handleSignUp)} className="signup-form-wrapper">
              <div className="row g-3">
                <div className="col-12">
                  <Form.Group>
                    <div className="position-relative">
                      <Form.Control type="email" placeholder="Enter your email address" {...register("email")} isInvalid={!!errors.email} style={{ paddingRight: "100px", borderColor: errors.email ? "red" : "" }} disabled={isOtpVerified} />
                      {!isOtpVerified && (
                        <span
                          className="send-otp-text"
                          onClick={async () => {
                            if (!resendDisabled && !loading && await trigger("email")) {
                              requestOtp(isOtpSent);
                            }
                          }}
                          style={{
                            position: "absolute",
                            right: "15px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: (resendDisabled || loading) ? "not-allowed" : "pointer",
                            color: (resendDisabled || loading) ? "#999" : "#6C63FF",
                            fontWeight: "600",
                            fontSize: "14px",
                            zIndex: 5
                          }}
                        >
                          {loading ? "Sending..." : (resendDisabled ? `Resend in ${resendTimer}s` : (isOtpSent ? "Resend OTP" : "Send OTP"))}
                        </span>
                      )}
                    </div>
                    <Form.Control.Feedback type="invalid" style={{ display: !!errors.email ? "block" : "none" }}>{errors.email?.message}</Form.Control.Feedback>
                  </Form.Group>
                </div>

                {isOtpSent && (
                  <div className="col-12">
                    <Form.Group>
                      <div className="position-relative">
                        <Form.Control type="text" placeholder="Confirm OTP" {...register("otp")} isInvalid={!!errors.otp || !!otpError} style={{ paddingRight: "100px" }} disabled={isOtpVerified} />
                        {!isOtpVerified ? (
                          <span onClick={handleVerifyOtpAction} style={{ position: "absolute", right: "15px", top: "50%", transform: "translateY(-50%)", cursor: "pointer", color: "#28a745", fontWeight: "600", fontSize: "14px", zIndex: 5 }}>Verify OTP</span>
                        ) : (
                          <span style={{ position: "absolute", right: "15px", top: "50%", transform: "translateY(-50%)", color: "#28a745", fontSize: "14px", zIndex: 5 }}>✓ Verified</span>
                        )}
                      </div>
                      <Form.Control.Feedback type="invalid" style={{ display: (!!errors.otp || !!otpError) ? "block" : "none" }}>{errors.otp?.message || otpError}</Form.Control.Feedback>
                    </Form.Group>
                  </div>
                )}

                {isOtpVerified && (
                  <>
                    <div className="col-12">
                      <Form.Group>
                        <Form.Control type="text" placeholder="First Name" {...register("firstName")} isInvalid={!!errors.firstName} />
                        <Form.Control.Feedback type="invalid">{errors.firstName?.message}</Form.Control.Feedback>
                      </Form.Group>
                    </div>
                    <div className="col-12">
                      <Form.Group>
                        <Form.Control type="text" placeholder="Last Name" {...register("lastName")} isInvalid={!!errors.lastName} />
                        <Form.Control.Feedback type="invalid">{errors.lastName?.message}</Form.Control.Feedback>
                      </Form.Group>
                    </div>

                    <div className="col-md-4">
                      <Form.Group>
                        <Select
                          options={countryList.map(c => ({ value: c.countryName, label: c.countryName, isdCode: c.isdCode, countryCode: c.countryCode }))}
                          formatOptionLabel={({ countryCode, isdCode }) => (
                            <div className="d-flex align-items-center gap-1">
                              {countryCode && <img src={`https://flagcdn.com/w20/${countryCode.toLowerCase()}.png`} alt="" style={{ width: "16px", height: "12px" }} />}
                              <span style={{ fontSize: "13px" }}>{isdCode}</span>
                            </div>
                          )}
                          placeholder="Country"
                          onChange={(opt) => {
                            if (opt) {
                              setSelectedCountry(opt); setIsdCode(opt.isdCode);
                              setValue("country", opt.value); setValue("isdCode", opt.isdCode);
                            }
                          }}
                          value={selectedCountry}
                          styles={customStyles}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-8">
                      <Form.Group>
                        <Form.Control type="tel" placeholder="Phone Number" {...register("mobileNumber")} isInvalid={!!errors.mobileNumber} />
                        <Form.Control.Feedback type="invalid">{errors.mobileNumber?.message}</Form.Control.Feedback>
                      </Form.Group>
                    </div>

                    <div className="col-12">
                      <Form.Group>
                        <div className="input-icon-wrapper">
                          <Form.Control type={visible ? "text" : "password"} placeholder="Password" {...register("password")} isInvalid={!!errors.password} />
                          <i
                            className={`bi ${visible ? "bi-eye" : "bi-eye-slash"} toggle-password-icon`}
                            onClick={() => setVisible(!visible)}
                            style={{ fontSize: "20px" }}
                          ></i>
                        </div>
                        <Form.Control.Feedback type="invalid" style={{ display: !!errors.password ? "block" : "none" }}>{errors.password?.message}</Form.Control.Feedback>
                      </Form.Group>
                    </div>
                    <div className="col-12">
                      <Form.Group>
                        <div className="input-icon-wrapper">
                          <Form.Control type={visible2 ? "text" : "password"} placeholder="Confirm Password" {...register("confirmPwd")} isInvalid={!!errors.confirmPwd} />
                          <i
                            className={`bi ${visible2 ? "bi-eye" : "bi-eye-slash"} toggle-password-icon`}
                            onClick={() => setVisible2(!visible2)}
                            style={{ fontSize: "20px" }}
                          ></i>
                        </div>
                        <Form.Control.Feedback type="invalid" style={{ display: !!errors.confirmPwd ? "block" : "none" }}>{errors.confirmPwd?.message}</Form.Control.Feedback>
                      </Form.Group>
                    </div>

                    <div className="col-12 mt-3">
                      <Form.Group className="mb-2">
                        <Form.Check
                          type="checkbox"
                          id="privacyPolicy"
                          {...register("privacyPolicy")}
                          isInvalid={!!errors.privacyPolicy}
                          label={
                            <span>
                              I understand and agree to the{" "}
                              <a href="https://zexprwire.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
                                Privacy Policy
                              </a>.
                            </span>
                          }
                        />
                      </Form.Group>

                      <Form.Group className="mb-2">
                        <Form.Check
                          type="checkbox"
                          id="termsOfService"
                          {...register("termsOfService")}
                          isInvalid={!!errors.termsOfService}
                          label={
                            <span>
                              I understand and agree to the{" "}
                              <a href="https://zexprwire.com/terms-of-service-for-zex-pr-wire/" target="_blank" rel="noopener noreferrer">
                                Terms of Service
                              </a>.
                            </span>
                          }
                        />
                      </Form.Group>

                      <Form.Group className="mb-2">
                        <Form.Check
                          type="checkbox"
                          id="editorialGuidelines"
                          {...register("editorialGuidelines")}
                          isInvalid={!!errors.editorialGuidelines}
                          label={
                            <span>
                              I understand and agree to the{" "}
                              <a href="https://zexprwire.com/editorial-guidelines/" target="_blank" rel="noopener noreferrer">
                                Editorial Guidelines
                              </a>.
                            </span>
                          }
                        />
                      </Form.Group>
                    </div>

                    <div className="col-12">
                      <button type="submit" className="signin_btn w-100" disabled={loading}>{loading ? "Signing up..." : "Sign Up"}</button>
                    </div>
                  </>
                )}

                <div className="col-12 mt-3 text-center">
                  <p className="mb-0" style={{ fontSize: "14px", color: "#666" }}>
                    Already have an account?{" "}
                    <Link to="/" style={{ color: "#595fde", fontWeight: "600" }}>
                      Login
                    </Link>
                  </p>
                </div>
              </div>
            </Form>
          </div>
        </Layout>
      </div>
    </div>
  );
}

